import Button from "components/Button";
import React from "react";
import { useHistory } from "react-router-dom";

import "./index.scss";

const EMPaymentPageSuccess = () => {
  const history = useHistory();
  return (
    <div className="success-payment-wrapper">
      <div className="container">
        <div className="headline">
          <p className="exclamation">HOORAY!</p>
          <p className="header">You have successfully booked an EM Machine!</p>
        </div>
        <p className="details">
          Please wait and we will reach out to you for your booking updates. For
          the meantime, if you have any questions or concerns, just reach out to
          us by emailing{" "}
          <a className="email" href="mailto:support@datafarming.com.au">
            support@datafarming.com.au
          </a>{" "}
        </p>
        <Button
          data-testid="exit-to-dashboard-button"
          icon="home"
          label="Back to dashboard"
          type="outlined"
          color="white"
          prepend
          onClick={() => history.push("/dashboard")}
        />
      </div>
    </div>
  );
};

export default EMPaymentPageSuccess;
